module.exports = __webpack_public_path__ + "img/logo-google-analytics.96bf4718.svg";